import React, { KeyboardEvent } from 'react';
import { FormikProps } from 'formik';
import Loading from '@jg/loading';
import { Trans } from 'react-i18next';
import CharacterCount from '@jg/character-count';
import { Button } from '@jg/react-tracking';
import classnames from 'classnames';
import {
  ICreateTeamComponentMapStateToProps,
  ICreateTeamFormProps,
} from '../../containers/CreateTeam/CreateTeam.d';
import FormError from '../FormError/FormError';

export const CreateTeamForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isInFlight,
}: // eslint-disable-next-line no-shadow
FormikProps<ICreateTeamFormProps> &
  Pick<
    // eslint-disable-next-line no-shadow
    ICreateTeamComponentMapStateToProps,
    'isInFlight' | 'isError'
  >) => {
  const preventEnterKey = (e: KeyboardEvent<HTMLTextAreaElement>) =>
    e.key === 'Enter' && e.preventDefault();

  const textareaClasses: string = classnames({
    'jg-form-control create-team__form ': true,
    'jg-form-control--with-error': errors.teamName,
  });

  const isButtonDisabled = Boolean(
    values.teamName.length === 0 || errors.teamName || isInFlight,
  );

  return (
    <form onSubmit={handleSubmit} className="jg-space-mtmd">
      <div className="jg-input-wrapper jg-space-mbmd">
        <div className="create-team__input">
          <label
            className="jg-h3 jg-display-b jg-space-mbxs"
            htmlFor="jg-tc-create-team-input"
          >
            <Trans i18nKey="content.createteam.teamName" />
          </label>
          <textarea
            id="jg-tc-create-team-input"
            className={textareaClasses}
            name="teamName"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.teamName}
            onKeyPress={preventEnterKey}
            maxLength={100}
          />
          <CharacterCount value={values.teamName} maxLength={100}>
            {({ charactersRemaining }) => (
              <span className="jg-form-control--with-character-count jg-text--small">
                {charactersRemaining}
                <span className="jg-sr-only">
                  <Trans i18nKey="global.textarea.charactersRemaining" />
                </span>
              </span>
            )}
          </CharacterCount>
        </div>
        {touched.teamName &&
          errors.teamName && <FormError message={errors.teamName} />}
      </div>
      <div className="jg-tc-button-container jg-tc-button-container__align-left">
        <Button
          id="jg-tc-create-team-continue-button"
          disabled={isButtonDisabled}
          type="submit"
          className="jg-btn jg-space-mbmd"
          trackingData={{
            action_name: 'click',
            subtype: 'button',
            event: 'click',
            event_value: 'lets go',
            page_section: 'page creation > create a team',
          }}
        >
          {isInFlight ? (
            <Loading size="small" colour="white" />
          ) : (
            <Trans i18nKey="content.createteam.button" />
          )}
        </Button>
      </div>
    </form>
  );
};

export default CreateTeamForm;
